<app-header (toggleMenuSidebar)="toggleMenuSidebar()"></app-header>
<app-menu-side-bar class="main-sidebar elevation-4"></app-menu-side-bar>
<div class="content-wrapper">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<aside class="control-sidebar control-sidebar-dark"></aside>
<div id="sidebar-overlay" (click)="toggleMenuSidebar()"></div>